import {
  object,
  string
} from "yup";

import "./schemas";

const systemSettingsSchema = object({
  portalName: string()
    .trim()
    .required()
    .matches(
      /^[a-zA-Z0-9\-:;() ]*$/,
      "Only alphanumerics, hyphens, brackets, colons and semi-colons are allowed."
    ),
  mobileSuffix: string()
    .trim()
    .required()
    .matches(
      /^[a-zA-Z0-9\-:;()@. ]*$/,
      "Only alphanumerics, hyphens, brackets, colons, at signs, full stops and semi-colon are allowed."
    )
    .test(
      "At least four charaters",
      "Must be four or more characters",
      item => (item.length >= 4)
    )
    .test(
      "Must start with an @",
      "Must start with an @",
      item => (item.startsWith("@"))
    )
    .test(
      "Must have at least one full stop",
      "Must have at least one full stop",
      item => (item.indexOf(".") > 0)
    )
    .test(
      "Must have characters before and after a full stop",
      "Must have characters before and after a full stop",
      item => {
        if (item.endsWith(".") || item.indexOf("..") !== -1) {
          return false;
        }

        return true;
      }
    )
});

export default systemSettingsSchema;
